
export default API => ({
    
/**
  * 商联会注册
  * 响应数据data：{}
  */
  saveCompany ({data,params}) {
      return API({ 
          url: `/slh/v1/slhCompany/saveCompany`,
          method:  'post',
          data,
          params
      });
  },

})